export const formatDateAuto = (
	dateLiteral: string | number | Date,
	format: 'short' | 'medium' | 'long' = 'short',
	noTime = false,
	// undefined => default 'de-DE'; null => browser's default locale
	locale?: string | null
): string => {
	if (!dateLiteral) {
		return '';
	}

	const hasTime = !noTime && typeof dateLiteral === 'string' && /T\d{2}:\d{2}/.test(dateLiteral);
	// Numbers below 1e12 are Unix seconds (not ms) — multiply up to ms for Date
	const ts =
		typeof dateLiteral === 'number' && dateLiteral < 1e12 ? dateLiteral * 1000 : dateLiteral;
	const date = new Date(ts);
	return date.toLocaleString(locale === null ? undefined : (locale ?? 'de-DE'), {
		year: 'numeric',
		month: format === 'long' ? 'long' : format === 'medium' ? 'short' : '2-digit',
		day: format === 'short' ? '2-digit' : 'numeric',
		...(hasTime && { hour: '2-digit', minute: '2-digit' })
	});
};

export const formatNumber = (num: number | null | undefined, decimals?: number): string => {
	const n = num ?? 0;
	return (Number.isFinite(n) ? n : 0).toLocaleString(
		'de-DE',
		decimals !== undefined
			? { minimumFractionDigits: decimals, maximumFractionDigits: decimals }
			: undefined
	);
};

export function formatPrice(
	amountInCents: number,
	currency: string,
	locale: string = 'de'
): string {
	return new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: currency.toUpperCase(),
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).format(amountInCents / 100);
}
